import React, { useState, useEffect, PureComponent } from "react";
import "./css/SCPChart.css";
import { ReactPivot } from "./ReactPivot";

const SCPPivotChart = ({ jsonData, title }) => {
  const [inputData, setInputData] = useState([]);
  useEffect(() => {
    const jsonString = document.getElementById("inputData").textContent;
    if (jsonString) {
      const values = new Set();
      jsonData.forEach((item) => {
        values.add(item);
      });
      setInputData(Array.from(values));
      setInputData(jsonData);
    }
  }, []);

  return (
    <>
      <div className="chartTitle">{title}</div>
      <ReactPivot data={jsonData} />;
    </>
  );
};

export default SCPPivotChart;
